import React from "react";
import { useHistory, RouteChildrenProps } from "react-router-dom";
import {
  Button,
  FormHelperText,
  Link,
  makeStyles,
  TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import { setSelfUserWithToken, LoginApi, UsersApi } from "../../helpers";
import { AlertDialog } from "../../components";

/** スタイル定義 */
const useStyles = makeStyles(theme => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  helper: {
    textAlign: "center",
  },
}));

/** ログインフォーム */
export function LoginForm() {
  const classes = useStyles();
  const history: RouteChildrenProps["history"] = useHistory();

  const [isLoginError, setIsLoginError] = React.useState(false);
  const linkRef = React.useRef<HTMLAnchorElement>(null);

  React.useEffect(() => {
    let token: string;
    LoginApi.login({ username: "souya", password: "souya" })
      .then(response => {
        token = response.data.token;
        return UsersApi.self(token);
      })
      .then(response => {
        setSelfUserWithToken({ user: response.data, token })
        history.push("/");
        return true;
      })
      .catch(error => {
        setIsLoginError(true);
        return false;
      });
  }, [])

  return (
    <>
      <AlertDialog
        data={{
          open: isLoginError,
          title: "エラー",
          message: "現在利用できません。問い合わせからお問い合わせください。"
        }}
        handleClose={() => {
          setIsLoginError(true);
          if (linkRef.current) {
            linkRef.current.click();
          }
        }}
      />
      <Link href={"https://www.souya.biz/"} ref={linkRef} />
    </>
  );
  //--------------------
  // コンポーネント
  // return (
  //   <Formik
  //     // [HP稼働]: ユーザーを固定
  //     initialValues={{ username: "souya", password: "souya" }}
  //     onSubmit={(values, { setSubmitting, setStatus }) => {
  //       let token: string;
  //       LoginApi.login(values)
  //         .then(response => {
  //           token = response.data.token;
  //           return UsersApi.self(token);
  //         })
  //         .then(response => {
  //           // フィールドエラーの場合
  //           // setFieldError('email', 'email is already used');
  //           if (setSelfUserWithToken({ user: response.data, token })) {
  //             // TODO: 前回開いていたページから再開する仕組みを作る場合は
  //             // localStorageにパスの情報を保持するなど検討する
  //             history.push("/");
  //           } else {
  //             setSubmitting(false);
  //           }
  //           return true;
  //         })
  //         .catch(error => {
  //           let message;
  //           if (error.response && error.response.status === 400) {
  //             message = "ユーザー名またはパスワードが不正です";
  //           } else {
  //             message = "予期しないエラーが発生しました";
  //           }
  //           setStatus(message);
  //           setSubmitting(false);
  //           return false;
  //         });
  //     }}
  //   >
  //     {({
  //       values,
  //       errors,
  //       touched,
  //       status,
  //       handleChange,
  //       handleBlur,
  //       handleSubmit,
  //       isSubmitting,
  //     }) => (
  //       <form className={classes.form} noValidate onSubmit={handleSubmit}>
  //         <TextField
  //           type="username"
  //           name="username"
  //           variant="outlined"
  //           size="small"
  //           margin="dense"
  //           fullWidth
  //           label="ユーザーID"
  //           onChange={handleChange}
  //           onBlur={handleBlur}
  //           value={values.username}
  //           autoFocus
  //         />
  //         {errors.username && touched.username && errors.username}
  //         <TextField
  //           type="password"
  //           name="password"
  //           variant="outlined"
  //           size="small"
  //           margin="dense"
  //           fullWidth
  //           label="パスワード"
  //           onChange={handleChange}
  //           onBlur={handleBlur}
  //           value={values.password}
  //         />
  //         {errors.password && touched.password && errors.password}
  //         <Button
  //           type="submit"
  //           fullWidth
  //           variant="contained"
  //           color="primary"
  //           className={classes.submit}
  //           disabled={isSubmitting}
  //         >
  //           ログイン
  //         </Button>

  //         {/* エラーメッセージ */}
  //         <FormHelperText className={classes.helper} error>
  //           {status}
  //         </FormHelperText>
  //       </form>
  //     )}
  //   </Formik>
  // );
}
